export default {
	sec_10: {
		title: {
			one: '銀行の様',
			two: 'な両替',
		},
		desc: {
			one: '販売したり購入したり',
			two: '今でも両替するためにあっちこっちに行かれてますか？',
		},
		btn: {
			one: '会員登録',
			two: 'アプリダウンロード',
		},
	},
	sec_04: {
		title: {
			one: '両替してすぐ',
			two: '送金及び出金',
		},
		desc: {
			one: '暗号資産の購入と送金が難しいですか？',
			two: '銀行の様にお使い頂けます。すぐに送金及び出金が可能です。',
		},
		cards: {
			one: {
				title: {
					one: 'ボタン一度で',
					two: '簡単に両替ができます。',
				},
				description: {
					one: '自動為替、自動売却',
					two: 'とても簡単なインターフェース',
				},
			},
			two: {
				title: {
					one: '希望の資産をいつでも',
				},
				description: {
					one: '暗号資産と暗号資産間の両替も可能',
					two: '暗号資産をJPYSポイント',
					three: 'で両替も可能',
				},
			},
		},
	},
};
